module.exports = __webpack_public_path__ + "img/icon8.292a8442.png";